// // src/components/pages/Dashboard.jsx
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { APPLICATION_STATUS } from '../../constants/statusConstants';
// import { getCompanies, getJobs, getCandidates } from "../../services/api";
// import './Dashboard.css';


// const Dashboard = () => {
//   const navigate = useNavigate();
//   const [stats, setStats] = useState({
//     companies: 0,
//     jobs: 0,
//     candidates: 0,
//     placements: 0,
//     interviews: 0
//   });
//   const [statusCounts, setStatusCounts] = useState({});
//   const [recentPlacements, setRecentPlacements] = useState([]);
//   const [loading, setLoading] = useState(true);


//   useEffect(() => {
//   const user = JSON.parse(localStorage.getItem("user"));

//   if (!user) {
//     navigate("/");
//     return;
//   }

//   if (user.role === "admin") {
//     console.log("Admin logged in");
//   }

//   if (user.role === "recruiter") {
//     console.log("Recruiter logged in");
//   }

// }, []);


//   useEffect(() => {
//     loadDashboardData();
//   }, []);

// const loadDashboardData = async () => {
//   try {

//     const companiesRes = await getCompanies();
//     const jobsRes = await getJobs();
//     const candidatesRes = await getCandidates();

//     const companies = companiesRes.data;
//     const jobs = jobsRes.data;
//     const candidates = candidatesRes.data;

//     setStats({
//       companies: companies.length,
//       jobs: jobs.length,
//       candidates: candidates.length,
//       placements: 0,
//       interviews: 0
//     });

//     setLoading(false);

//   } catch (error) {
//     console.error(error);
//   }
// };

//   const getStatusColor = (status) => {
//     const colors = {
//       [APPLICATION_STATUS.RESUME_SENT]: 'status-resume',
//       [APPLICATION_STATUS.INTERVIEW_IN_PROGRESS]: 'status-interview',
//       [APPLICATION_STATUS.SELECTED]: 'status-selected',
//       [APPLICATION_STATUS.JOINED]: 'status-joined',
//       [APPLICATION_STATUS.REJECTED]: 'status-rejected'
//     };
//     return colors[status] || 'status-default';
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading dashboard...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard">
//       {/* Welcome Section */}
//       <div className="welcome-section">
//         <div className="welcome-content">
//           <h1>Welcome to JSK Placement CRM</h1>
//           <p>Manage your recruitment pipeline efficiently</p>
//         </div>
//         {/* <div className="welcome-actions">
//           <Link to="/companies/new" className="btn-primary">
//             + Add Company
//           </Link>
//           <Link to="/jobs/new" className="btn-secondary">
//             + Add Job
//           </Link>
//         </div> */}

        
//       </div>

//       {/* Stats Grid */}
//       <div className="stats-grid">
//         <div className="stat-card">
//           <div className="stat-icon company">🏢</div>
//           <div className="stat-content">
//             <h3>{stats.companies}</h3>
//             <p>Total Companies</p>
//           </div>
//           <Link to="/companies" className="stat-link">View All →</Link>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon job">💼</div>
//           <div className="stat-content">
//             <h3>{stats.jobs}</h3>
//             <p>Job Requirements</p>
//             <span className="stat-sub">{stats.jobs} Open Positions</span>
//           </div>
//           <Link to="/jobs" className="stat-link">View All →</Link>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon candidate">👤</div>
//           <div className="stat-content">
//             <h3>{stats.candidates}</h3>
//             <p>Candidates</p>
//           </div>
//           <Link to="/candidates" className="stat-link">View All →</Link>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon placement">📋</div>
//           <div className="stat-content">
//             <h3>{stats.placements}</h3>
//             <p>Placements</p>
//             <span className="stat-sub">Active Applications</span>
//           </div>
//           <Link to="/placements" className="stat-link">View All →</Link>
//         </div>
//       </div>

//       {/* Status Overview */}
//       <div className="status-section">
//         <h2>Placement Status Overview</h2>
//         <div className="status-grid">
//           {Object.values(APPLICATION_STATUS).map(status => (
//             <div key={status} className="status-item">
//               <div className={`status-indicator ${getStatusColor(status)}`}></div>
//               <div className="status-details">
//                 <span className="status-label">{status}</span>
//                 <span className="status-count">{statusCounts[status] || 0}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

      

//       {/* Quick Actions */}
//       <div className="quick-actions-section">
//         <h2>Quick Actions</h2>
//         <div className="quick-actions-grid">
//           <Link to="/companies/new" className="quick-action">
//             <div className="action-icon">🏢</div>
//             <h4>Add Company</h4>
//             <p>Register new client company</p>
//           </Link>
//           <Link to="/jobs/new" className="quick-action">
//             <div className="action-icon">💼</div>
//             <h4>Post Job</h4>
//             <p>Create job requirement</p>
//           </Link>
//           <Link to="/candidates/new" className="quick-action">
//             <div className="action-icon">👤</div>
//             <h4>Add Candidate</h4>
//             <p>Register new candidate</p>
//           </Link>
//           <Link to="/interviews/new" className="quick-action">
//             <div className="action-icon">🎯</div>
//             <h4>Schedule Interview</h4>
//             <p>Schedule new interview</p>
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;




// src/components/pages/Dashboard.jsx
// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { getCompanies, getJobs, getCandidates } from "../../services/api";
// import './Dashboard.css';

// const Dashboard = () => {

//   const [stats, setStats] = useState({
//     companies: 0,
//     jobs: 0,
//     candidates: 0
//   });

//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadDashboardData();
//   }, []);

//   const loadDashboardData = async () => {
//     try {
//       setLoading(true);
//       console.log("Dashboard API call...");

//       const results = await Promise.allSettled([
//         getCompanies(),
//         getJobs(),
//         getCandidates()
//       ]);

//       const companies = results[0]?.status === "fulfilled" ? results[0].value?.data : [];
//       const jobs = results[1]?.status === "fulfilled" ? results[1].value?.data : [];
//       const candidates = results[2]?.status === "fulfilled" ? results[2].value?.data : [];

//       setStats({
//         companies: companies?.length || 0,
//         jobs: jobs?.length || 0,
//         candidates: candidates?.length || 0
//       });

//     } catch (error) {
//       console.error("Dashboard Error:", error);
//     } finally {
//       setLoading(false); // ✅ always stop loader
//     }
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="spinner"></div>
//         <p>Loading dashboard...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard">

//       {/* Welcome */}
//       <div className="welcome-section">
//         <h1>Welcome to JSK Placement CRM</h1>
//         <p>Manage your recruitment pipeline efficiently</p>
//       </div>

//       {/* Stats */}
//       <div className="stats-grid">

//         <div className="stat-card">
//           <div className="stat-icon company">🏢</div>
//           <div className="stat-content">
//             <h3>{stats.companies}</h3>
//             <p>Total Companies</p>
//           </div>
//           <Link to="/companies" className="stat-link">View All →</Link>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon job">💼</div>
//           <div className="stat-content">
//             <h3>{stats.jobs}</h3>
//             <p>Job Requirements</p>
//           </div>
//           <Link to="/jobs" className="stat-link">View All →</Link>
//         </div>

//         <div className="stat-card">
//           <div className="stat-icon candidate">👤</div>
//           <div className="stat-content">
//             <h3>{stats.candidates}</h3>
//             <p>Candidates</p>
//           </div>
//           <Link to="/candidates" className="stat-link">View All →</Link>
//         </div>

//       </div>

//     </div>
//   );
// };

// export default Dashboard;



import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCompanies, getJobs, getCandidates } from "../../services/api";
import { useAuth } from "../../contexts/AuthContext";
import './Dashboard.css';

const Dashboard = () => {

  const { currentUser } = useAuth(); // ✅ AuthContext se currentUser le rahe hain
  
  const [stats, setStats] = useState({
    companies: 0,
    jobs: 0,
    candidates: 0
  });

  const [loading, setLoading] = useState(true);

  // ✅ Role check - Candidates.js ke same pattern follow kiya
  const isAdmin = currentUser && currentUser.role === "admin";
  const isRecruiter = currentUser && currentUser.role === "recruiter";

  useEffect(() => {
    loadDashboardData();
  }, []);

  const loadDashboardData = async () => {
    try {
      setLoading(true);

      // ✅ Admin: Sab kuch fetch karega
      // ✅ Recruiter: Sirf candidates fetch karega
      const results = await Promise.allSettled([
        isAdmin ? getCompanies() : Promise.resolve({ data: [] }),
        isAdmin ? getJobs() : Promise.resolve({ data: [] }),
        getCandidates() // Dono roles ke liye candidates fetch honge
      ]);

      const companies = results[0]?.status === "fulfilled" ? results[0].value?.data : [];
      const jobs = results[1]?.status === "fulfilled" ? results[1].value?.data : [];
      const candidates = results[2]?.status === "fulfilled" ? results[2].value?.data : [];

      setStats({
        companies: companies.length,
        jobs: jobs.length,
        candidates: candidates.length
      });

    } catch (error) {
      console.error("Dashboard Error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">

      {/* Welcome Section - Role-based welcome message */}
      <div className="welcome-section">
        <h1>Welcome to JSK Placement CRM</h1>
        <p>Manage your recruitment pipeline efficiently</p>
        {isRecruiter && (
          <small style={{ color: '#4CAF50', fontSize: '14px', display: 'block', marginTop: '8px' }}>
            🔑 Recruiter Mode - You can view and manage candidates
          </small>
        )}
        {isAdmin && (
          <small style={{ color: '#2196F3', fontSize: '14px', display: 'block', marginTop: '8px' }}>
            👑 Admin Mode - Full access to all features
          </small>
        )}
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">

        {/* ✅ Admin: Companies, Jobs, aur Candidates teeno dekhega */}
        {isAdmin && (
          <>
            <div className="stat-card">
              <div className="stat-icon company">🏢</div>
              <div className="stat-content">
                <h3>{stats.companies}</h3>
                <p>Total Companies</p>
              </div>
              <Link to="/companies" className="stat-link">View All →</Link>
            </div>

            <div className="stat-card">
              <div className="stat-icon job">💼</div>
              <div className="stat-content">
                <h3>{stats.jobs}</h3>
                <p>Job Requirements</p>
              </div>
              <Link to="/jobs" className="stat-link">View All →</Link>
            </div>

            {/* Admin bhi candidates dekhega */}
            <div className="stat-card">
              <div className="stat-icon candidate">👤</div>
              <div className="stat-content">
                <h3>{stats.candidates}</h3>
                <p>Total Candidates</p>
              </div>
              <Link to="/candidates" className="stat-link">View All →</Link>
            </div>
          </>
        )}

        {/* ✅ Recruiter: Sirf Candidates dekhega (Companies & Jobs hidden) */}
        {isRecruiter && (
          <div className="stat-card full-width-card">
            <div className="stat-icon candidate">👤</div>
            <div className="stat-content">
              <h3>{stats.candidates}</h3>
              <p>Total Candidates</p>
              {stats.candidates > 0 && (
                <small style={{ fontSize: '12px', color: '#666', marginTop: '5px', display: 'block' }}>
                  📋 Ready for recruitment
                </small>
              )}
            </div>
            <Link to="/candidates" className="stat-link">Manage Candidates →</Link>
          </div>
        )}

      </div>

      {/* Quick Actions - Role based */}
      <div className="quick-actions-section">
        <h3>Quick Actions</h3>
        <div className="actions-grid">
          {isRecruiter && (
            <>
              <Link to="/candidates" className="action-card">
                <span className="action-icon">➕</span>
                <span>Add New Candidate</span>
              </Link>
              <Link to="/candidates?import=true" className="action-card">
                <span className="action-icon">📥</span>
                <span>Import from Excel</span>
              </Link>
            </>
          )}
          {isAdmin && (
            <>
              <Link to="/companies" className="action-card">
                <span className="action-icon">🏢</span>
                <span>Add Company</span>
              </Link>
              <Link to="/jobs" className="action-card">
                <span className="action-icon">💼</span>
                <span>Post Job</span>
              </Link>
              <Link to="/candidates" className="action-card">
                <span className="action-icon">👥</span>
                <span>Manage Candidates</span>
              </Link>
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default Dashboard;